import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { USER_DETAILS_FRAGMENT } from '../fragments'

const USERS_QUERY = gql`
  query users {
    users {
      results {
        ...UserDetailsFragment
        roles {
          ...SimpleEntityFragment
        }
        isDeleted
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${USER_DETAILS_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default USERS_QUERY
